export default {
    'before-analysis.png': 'before-analysis.png',
    'analyzing.png': 'analyzing.png',
  }
  